import React from 'react'

import { OverviewProductStatusEnum, SalesReceivementProduct } from '../../../ReceivementTypes'
import { ProductTable } from './ProductTable'
import { WrongProductTable } from './WrongProductTable'

interface Props {
  product: SalesReceivementProduct
}

const ReceivementPurchaseTable = ({ product }: Props) =>
  (product.status !== OverviewProductStatusEnum.WRONG ? (
    <ProductTable product={product} />
  ) : <WrongProductTable product={product} />)

export { ReceivementPurchaseTable }
